// removed by extract-text-webpack-plugin
module.exports = {"button":"icon-button__button___1ju2j"};


//////////////////
// WEBPACK FOOTER
// ./core/src/components/button/icon-button.css
// module id = 1177
// module chunks = 0